import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import { Seo } from 'src/components/seo';
// import { MobileProvider, useIsMobile } from 'src/contexts/mobile-context';

const PageSection = ({ title, rootRef, children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  return (
    <>
      <Seo title={title} />
      <Box component="main" ref={rootRef} sx={{ flexGrow: 1, py: 0.5 }}>
        <Container maxWidth="xl" sx={{ px: isMobile ? 1 : 3 }}>
          {typeof children === 'function' ? children({ isMobile }) : children}
        </Container>
      </Box>
    </>
  );
};

PageSection.propTypes = {
  title: PropTypes.string.isRequired,
  rootRef: PropTypes.any,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func, // if using children as function
  ]),
};

export default PageSection;
